import { Box, Typography, Link, Grid, Divider } from "@mui/material";
import 'aos/dist/aos.css'; // Import AOS styles (remove if not used)

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#3b76b2',
        color: '#fff',
        padding: { xs: '2rem 1rem', sm: '2rem 1rem' },
        mt: 'auto', // Pushes footer to bottom of page
      }}
    >
      <Grid container spacing={4} justifyContent="space-around">
        {/* Contact Information */}
        <Grid>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Office
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="mailto:admin@mindsinaction.com.na" color="inherit" underline="hover">
              admin@mindsinaction.com.na
            </Link>
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="tel:+264818692038" color="inherit" underline="hover">
              +264 81 869 2038
            </Link>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }} fontSize={'1rem'}>
            6 Andimba Toivo-ya-Toivo <br />
            Suiderhof, Windhoek<br />
            Huster Machinetool Building, First Floor
          </Typography>
          <br/>
          <Typography variant="h5" gutterBottom fontWeight={700} color="#f8da61">
            Operating Hours
          </Typography>
          <Typography variant="body" color="#f8da61">
            Mon - Fri: 09:00 AM - 05:00 PM<br />
            Sat - Sun: Closed
          </Typography>
        </Grid>

        {/* Navigation Links */}
        <Grid>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            About
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="/about" color="inherit" underline="hover">
              Our Story
            </Link>
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="/modules" color="inherit" underline="hover">
              Modules
            </Link>
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="/media" color="inherit" underline="hover">
              Blog
            </Link>
          </Typography>
        </Grid>

        <Grid>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Services
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="/services/ICT/?code=1250000" color="inherit" underline="hover">
              ICT Services
            </Link>
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="/services/STEAM/?code=1250001" color="inherit" underline="hover">
              STEAM
            </Link>
          </Typography>
          <Typography variant="body2" fontSize={'1rem'}>
            <Link href="/services/Engineering/?code=1250005" color="inherit" underline="hover">
              Engineering Services
            </Link>
          </Typography>
        </Grid>

        {/* Social Media */}
        <Grid>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Follow Us On
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Link href="https://www.facebook.com/share/18MsyKUKyZ/?mibextid=wwXIfr" color="inherit" underline="hover" target='_blank'>
              Facebook
            </Link>
            <Link href="https://www.tiktok.com/@mindsinaction?_t=8co12SVnpHp&_r=1" color="inherit" underline="hover" target='_blank'>
              Tiktok
            </Link>
            <Link href="https://www.instagram.com/minds_in_action/" color="inherit" underline="hover" target='_blank'>
              Instagram
            </Link>
            <Link href="https://www.linkedin.com/company/mindsinaction-steam/?viewAsMember=true" color="inherit" underline="hover" target='_blank'>
              Linkedin
            </Link>
            <Link href="https://whatsapp.com/channel/0029VawZ4YTAInPuOrovyC10" color="inherit" underline="hover" target='_blank'>
              WhatsApp
            </Link>
          </Box>
        </Grid>

        {/* Google Map */}
        <Grid>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Find Us
          </Typography>
          <Box
            sx={{
              height: '200px',
              borderRadius: '8px',
              overflow: 'hidden',
            }}
          >
            <iframe 
            title="footer"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3668.614135239592!2d17.07651031513547!3d-22.57051838517184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDM0JzEzLjkiUyAxN8KwMDQnMzUuNCJF!5e0!3m2!1sen!2sna!4v1698765432100!5m2!1sen!2sna"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3, backgroundColor: '#fff' }} />

      {/* Copyright */}
      <Typography variant="body2" align="center">
        ©2025 Mindsinaction - All rights reserved. Developed by{' '}
        <Link href="https://mindsinaction.com.na" color="inherit" underline="hover">
          Mindsinaction
        </Link>.
      </Typography>
    </Box>
  );
};

export default Footer;